import React from 'react';
import Styles from './styles';
import { Button, Dropdown, Tag } from 'antd';
import { PlaySmartClip } from '../../../../features/shared/components/Icons/PlaySmartClip';
import { ClipFolderItem } from '../../../../features/shared/components/Icons/ClipFolderItem';
import { FolderFolderItem } from '../../../../features/shared/components/Icons/FolderFolderItem';
import { MoreOutlined } from '@ant-design/icons';
import { Unstar } from '../../../../features/shared/components/Icons/Unstar';
import { secondsToHms } from '../../../../utils/dateUtils';

const {
  Container,
  Details,
  DetailDataContainer,
  DetailData,
  DetailLabel,
  Name,
  StarredByLabel,
  StarredByName,
  MenuTitle,
  ItemContainer,
  ItemLabel,
} = Styles;

interface Props {
  checked: boolean;
  name: string;
  type: string;
  folderName: string;
  thumbnail: string | null;
  starredBy: string;
  daysSinceMeeting: string;
  duration: string;
  itemId: string;
  eventId: string;
  onCheckChange: (value: boolean) => unknown;
  onRemove: () => unknown;
  onClick: () => unknown;
}

export const FolderItem: React.FC<Props> = ({
  onClick,
  onRemove,
  starredBy,
  name,
  type,
  daysSinceMeeting,
  duration,
  folderName,
}) => {
  const days = Number(daysSinceMeeting) > 1 || Number(daysSinceMeeting) === 0 ? 'days ' : 'day ';

  return (
    <Container>
      <Details>
        <Name id="folder-item-name" onClick={onClick}>
          {name.replaceAll('•', '').trim()}
        </Name>
        <span>
          <StarredByLabel>Starred by </StarredByLabel>
          <StarredByName>{starredBy}</StarredByName>
        </span>
        <DetailData>
          <DetailDataContainer>
            <PlaySmartClip />
            <DetailLabel>
              {daysSinceMeeting} {days}
              ago
            </DetailLabel>
          </DetailDataContainer>
          <DetailDataContainer>
            <ClipFolderItem />
            <DetailLabel>{secondsToHms(parseInt(duration))}</DetailLabel>
          </DetailDataContainer>
          <DetailDataContainer>
            <FolderFolderItem />
            <DetailLabel>{folderName}</DetailLabel>
          </DetailDataContainer>
          {type && (
            <DetailDataContainer>
              <Tag>{type}</Tag>
            </DetailDataContainer>
          )}
        </DetailData>
      </Details>
      <Dropdown
        trigger={['click']}
        menu={{
          items: [
            {
              key: 'header',
              disabled: true,
              label: <MenuTitle>Smart Clip™️ Options</MenuTitle>,
            },
            {
              key: 'divider-1',
              type: 'divider',
            },
            {
              key: 'unstar-item',
              label: (
                <ItemContainer onClick={() => onRemove()}>
                  <Unstar />
                  <ItemLabel>Remove insight</ItemLabel>
                </ItemContainer>
              ),
            },
          ],
        }}
      >
        <Button type="text" icon={<MoreOutlined />} />
      </Dropdown>
    </Container>
  );
};
